module.exports = __webpack_public_path__ + "img/NewsCenterDetails7_pic1.b1efd43c.png";